import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { getSettings, getSettingsErrorMessage } from "../services/whatsappSetupApi";
import { getDefaultWhatsAppPath } from "../utils/whatsappPermissions";

export function useWhatsAppGate(navigate) {
  const [setupOpen, setSetupOpen] = useState(false);
  const [initialSettings, setInitialSettings] = useState(null);
  const [checking, setChecking] = useState(false);

  const resolveWhatsAppPath = useCallback(() => {
    return getDefaultWhatsAppPath() || "/whatsapp";
  }, []);

  const enterWhatsApp = useCallback(() => {
    navigate(resolveWhatsAppPath());
  }, [navigate, resolveWhatsAppPath]);

  const checkConfigured = useCallback(async () => {
    const settings = await getSettings();
    return Boolean(settings.configured);
  }, []);

  const openSetupIfNeeded = useCallback(async () => {
    setChecking(true);
    try {
      const settings = await getSettings();
      if (settings.configured) {
        enterWhatsApp();
        return true;
      }
      setInitialSettings(settings);
      setSetupOpen(true);
      return false;
    } catch (err) {
      toast.error(getSettingsErrorMessage(err, "Failed to check WhatsApp setup"));
      return false;
    } finally {
      setChecking(false);
    }
  }, [enterWhatsApp]);

  const handleSetupSuccess = useCallback(() => {
    setSetupOpen(false);
    toast.success("WhatsApp connected successfully");
    enterWhatsApp();
  }, [enterWhatsApp]);

  const handleSetupCancel = useCallback(() => {
    setSetupOpen(false);
  }, []);

  return {
    setupOpen,
    setSetupOpen,
    initialSettings,
    checking,
    checkConfigured,
    openSetupIfNeeded,
    handleSetupSuccess,
    handleSetupCancel,
    resolveWhatsAppPath,
  };
}
